export default __webpack_public_path__ + "static/media/presidents_harrison.1d7eb520.png";